<header class="sticky top-0 z-40">
  <nav aria-label="Main navigation">
    <div class="nav-bar">
      <div class="flex justify-between flex-grow">
        <div class="flex flex-row">
          <a class="nav-title" [routerLink]="['/']" aria-label="L&R Midland home">
            <img src="../../assets/images/lr-site-logo-01.png" class="object-contain h-9" alt="L&R Midland logo" />
          </a>
          <div class="env-badge" *ngIf="isStaging">STAGING ENVIRONMENT</div>
          <div class="env-badge" *ngIf="isDevelopment">DEVELOPMENT ENVIRONMENT</div>
        </div>
        <div class="w-full relative flex justify-end md:w-auto px-4 md:static md:block md:justify-end">
          <button
            class="text-gray-700 cursor-pointer text-xl leading-none py-1 border border-solid border-transparent rounded bg-transparent block md:hidden hover:bg-gray-100"
            type="button" (click)="toggle()" aria-label="Toggle navigation menu" [attr.aria-expanded]="isExpanded">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      <div class="nav-menu" *ngIf="isAuthenticated | async"
        [ngClass]="{'hidden': !isExpanded, 'flex flex-col md:flex-row md:justify-end': isExpanded}"
        class="md:flex mt-2 md:mt-0 md:items-center">
        <a class="nav-menu-item justify-start" routerLinkActive="active" [routerLink]="['/contracts']">Contracts</a>
        <a class="nav-menu-item" routerLinkActive="active" [routerLink]="['/voyages']">Moves</a>
        <a class="nav-menu-item" routerLinkActive="active" [routerLink]="['/voyages/list-by-owner']">Traffics</a>
        <a class="nav-menu-item" routerLinkActive="active" [routerLink]="['/company']">Company</a>
        <a class="nav-menu-item" routerLinkActive="active" [routerLink]="['/maintenance']">Maintenance</a>
        <a class="nav-menu-item" routerLinkActive="active" [routerLink]="['/reports']">Reports</a>
        <a class="nav-menu-item" routerLinkActive="active" *ngIf="larsEnabled | async"
          [routerLink]="['/ai-assistant']"
          title="L&amp;R Midland's AI-enabled Reporting System">LARS</a>
        <a class="nav-menu-item" routerLinkActive="active" [routerLink]="['/release-notes']">Release Notes</a>
        <a class="nav-menu-item" routerLinkActive="active" *ngIf="(role | async) === 'Administrator'"
          [routerLink]="['/admin']">Admin</a>
      </div>
      <app-login-menu [ngClass]="{'hidden': !isExpanded, 'flex': isExpanded}" class="md:flex mt-2 md:mt-0">
      </app-login-menu>
    </div>
  </nav>
</header>
